export default __webpack_public_path__ + "static/media/website.71308072.svg";